<template>

    <div class="container card p-5 shadow m-auto">
        
        <h1>Create Step for Category {{currentCategory.title}}</h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Title</span>
                </div>
                <input v-model="categoryStep.title" type="text" class="form-control" placeholder="Enter Title">
            </div>

            <div class="form-group">
                <div class="input-group-prepend w-100">
                    <span class="input-group-text w-100">{{$t("HELP")}}</span>
                </div>
                <html-editor v-model="categoryStep.help"/>
            </div>
            <div class="form-group">
                <div class="input-group-prepend w-100">
                    <span class="input-group-text w-100">{{$t("INFO_CONTENT")}}</span>
                </div>
                <html-editor v-model="categoryStep.infoConten"/>
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" for="inputGroupSelect01">{{$t('TYPE')}}</span>
                </div>
                <select class="custom-select" v-model="categoryStep.treatment" id="inputGroupSelect01">
                    <option value="false">{{$t('NORMAL')}}</option>
                    <option value="true">{{$t('TREATMENT')}}</option>
                </select>
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" for="inputGroupSelect02">{{$t('IS_LAST')}}</span>
                </div>
                <select class="custom-select" v-model="categoryStep.isLast" id="inputGroupSelect02">
                    <option value="true">{{$t('TRUE')}}</option>
                    <option value="false">{{$t('FALSE')}}</option>
                </select>
            </div>
            <button @click="addCategoryStep()" type="button" class="btn btn-primary mb-3">Add CategoryStep</button>
        </div>        
    </div>

</template>

<script>
import HtmlEditor from './../../misc/HtmlEditor';

export default {
    data() {
        return {
            currentCategory: {},
            categoryStep: {
                title: null,
                help: null,
                infoContent: null,
                treatment: false,
                isLast: false,
                id: null,
            },
            response: {}
        }
    },
    components: {
        HtmlEditor
    },
    methods: {
        addCategoryStep: function(){
            if(this.keyIndex === -1){
                this.response = {"success": false, "message": "Given Title Translation Key is either not generated yet or not selected"}
            }
            else
            {
                let self = this;
                this.categoryStep.categoryId = this.$route.params.categoryId;
                this.$http.post('/api/category-steps/add/', this.categoryStep)
                .then(response => {
                    self.response = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
            }
        },
        loadCurrentCategory: function() {
            let self = this;
            this.$http.get('/api/categories/get/' + this.$route.params.categoryId)
            .then(response => {
                self.currentCategory = response.data;
                
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        }
    },
    mounted: function() {
        this.loadCurrentCategory();
    },
    watch: {
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push(`/admin/categories/${this.$route.params.categoryId}/steps/`);
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },
    }
    
}
</script>

<style lang="scss">
.autocomplete{
  position: relative;
  display: inline-block;
}
input{
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
  &[type=text]
  {
    width: 100%;
  }
}

.autocomplete-items
{
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  input{
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
    &:hover{
      background-color: #e9e9e9;
    }
  }
}
.autocomplete-active{
  background-color: DodgerBlue !important;
  color: #ffffff;
}


div{
    span.input-group-text {
        width: 85px;
    }
}

.form-control[readonly] {
    background-color: white;
}
</style>
